export const contentTableConfig = {
  title: '直播客户次日电话情况',
  propList: [
    {prop: 'channelName', label: '直播间名称', minWidth: '80'},
    {prop: 'deptName', label: ' 部门名称', minWidth: '80'},
    {prop: 'empName', label: '员工姓名', minWidth: '80'},
    {prop: 'consumerWxUnionId', label: '客户unionId', minWidth: '80'},
    {prop: 'consumerNickName', label: '客户昵称', minWidth: '80'},
    {prop: 'accessTime', label: '访问时间', minWidth: '80'},
    {prop: 'duration', label: '观看直播时长:单位秒', minWidth: '80'},
    {prop: 'isPhoneCommunicationStr', label: '是否电话沟通', minWidth: '80'},
    {prop: 'empCreatedAt', label: '业务员加入时间', minWidth: '120'},
    {prop: 'lastMonthSalesAmount', label: '业务员上月的业绩', minWidth: '80'},
    {prop: 'lastMonthSalesFlagStr', label: '上月业绩是否达标', minWidth: '80'},
    {prop: 'phoneSalesAmount', label: '电话当日的业绩', minWidth: '80'},
  ],
  childrenProps: {
    rowStyle: changRed,
  },
  showIndexColumn: false,
  showSelectColumn: false
}
function changRed({ row }: { row: any }) {
  if (row.lastMonthSalesFlagStr == "否") { // 变颜色的条件
    return {
      color: "red"  // 这个return的就是样式 可以是color 也可以是backgroundColor
    }
  }
}
